<template>
<div class="ServicePreview ">
  <!-- Компонент ServicePreview -->
  <div class="wrapper">
    <div class="wrapper">
      <div class="image">
        <v-img
          :src="preview.main_image_url"
          width="150"
          height="150"
          :contain="true"
        />
      </div>
      <div class="body">
        <div class="title pb-4">
          <h3>{{preview.name}}</h3>
          <div
            v-if="profilePage"
            class="d-flex gap-3"
          >
            <span>Пройдено: 1</span>
            <span>Остаток: 0</span>
          </div>
        </div>
        <div class="description">
          {{preview.short_description}}
        </div>
      </div>
    </div>
    <div class="price" v-if="!profilePage">
      <div class="price__block">
        <div class="badge" v-if="Number(preview.discount_price)">
          Скидка {{calculatedPriceDiscount}} %
        </div>
        <div class="not_sale" v-if="!Number(preview.discount_price) && Number(preview.price)">
          {{preview.price}} ₽
        </div>

        <div class="sale" v-else>
          <div class="text-decoration-line-through text-gray" v-if="Number(preview.price)">{{preview.price}} ₽</div>
          <div class="main-price" v-if="Number(preview.discount_price)">{{preview.discount_price}} ₽ </div>
        </div>
      </div>
      <v-btn
        v-if="!itemDetailInBasket && Number(preview.price)"
        large
        color="white"
        outlined
        @click="addTocart(preview.id)"
      >
        В корзину
      </v-btn>
      <BasketCounter
        v-else
        :id="preview.id"
      />
<!--      <v-btn-->
<!--        v-else-->
<!--        class="bg-gray"-->
<!--        large-->
<!--        color="grey-500"-->
<!--        outlined-->
<!--        :disabled="true"-->
<!--      >-->
<!--        В корзине-->
<!--      </v-btn>-->
      <v-btn
        large
        class="background_transparent"
        color="white"
        outlined
        @click="goToDetail(preview.id)"
      >
        Узнать больше
      </v-btn>
    </div>
    <div class="price" v-if="profilePage">
      <v-btn
        large
        color="white"
        outlined
      >
        Пройти
      </v-btn>
      <v-btn
        class="bg-gray"
        large
        color="grey-500"
        outlined
        :disabled="true"
      >
        Пройдено
      </v-btn>
      <v-btn
        large
        class="background_transparent"
        color="white"
        outlined
        @click="goToDetail(preview.id)"
      >
        Подробнее
      </v-btn>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BasketCounter from '@/components/basket/BasketCounter.vue';

/**
 * Компонент: ServicePreview
 * Описание:
 */
export default {
  name: 'ServicePreview',

  components: { BasketCounter },

  props: {
    preview: {
      type: Object,
      required: true
    },
    profilePage: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      basketUser: 'basket/basket/basketUser',
      itemInBasket: 'basket/basket/itemInBasket'
    }),
    price() {
      return Number(this.preview.price);
    },
    discountPrice() {
      return Number(this.preview.discount_price);
    },
    calculatedPriceDiscount() {
      const percentage = ((this.price - this.discountPrice) / this.price) * 100;
      return Math.round(percentage);
    },
    itemDetailInBasket() {
      return this.itemInBasket(this.preview.id);
    }
  },
  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      addToBasket: 'basket/basket/addToBasket',
      fetchUserBasket: 'basket/basket/fetchUserBasket',
    }),
    goToDetail(id) {
      this.$router.push({ name: 'serviceDetail', params: { id } });
    },
    async addTocart(id) {
      const data = {
        service_card_id: id,
        quantity: 1
      };
     await this.addToBasket(data);
     await this.fetchUserBasket();
    }
  },
};
</script>

<style scoped lang="scss">
.ServicePreview {
  /* Стили компонента */
  & .wrapper{
    display: flex;
    flex-wrap: nowrap;
    gap: 12px;
    padding: 24px !important;
    background: white;
    width: 100%;
    max-width: 1200px;
    border-radius: 8px;

    & .body{
      & .title{
        & h3{
          font-size: 20px;
          color: var(--color-blue-500);
          font-weight: 600;
          line-height: 130%;
        }

        & span{
          padding-top: 8px;
          font-size: 14px;
        }
      }

      & .description{
        font-size: 16px;
        color: var(--color-blue-500);
        font-weight: 400;
        display: -webkit-box;
        -webkit-line-clamp: 3; /* Количество строк */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis; /* Добавляет многоточие */
      }
    }
    & .price{
      display: flex;
      flex-direction: column;
      gap: 16px;
      min-width: 250px;
      justify-content: center;
      & .v-btn{
        background: var(--color-blue-500);
        border-radius: 6px;
        font-size: 16px;
        width: 100%;
        padding: 10px 16px;
        ::v-deep span{
          line-height: 24px;
        }
        &.background_transparent{
          background: transparent;
          color: var(--color-blue-500)!important;
        }
        &.bg-gray{
          background: var(--color-grey-200);
          color: var(--color-grey-500);
          border: none;
        }
      }
      & .price__block{
        font-weight: 600;
        font-size: 20px;
        text-align: right;
        display: flex;
        flex-direction: column;
        align-items: flex-end ;
        gap: 16px;
        & .badge{
          padding: 8px 12px;
          background: #FAC40D;
          color: var(--color-blue-500);
          border-radius: 8px;
          border: none;
          font-size: 14px;
        }
        & .not_sale{
          font-weight: 600;
          font-size: 20px;
          text-align: right;
        }
        & .sale{
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-evenly;
          flex-direction: row;
          gap: 8px;
          & .main-price{
            color: #5F2532;
          }
        }
      }
    }
  }
}
</style>
